import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';

class Button extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    if(this.props.onClick){
      this.props.onClick()
    }
  }

  render() {
    const { className } = this.props
    return (
      <button 
        className={cx(styles.button, className, {[styles.primary]: this.props.primary})} 
        onClick={this.handleClick} 
        disabled={this.props.disabled}
        type={this.props.type}>
        {this.props.primary && 
          <i className="paperflite-tick" aria-hidden="true"></i>
        }
        <span className={styles.title}>{this.props.title}</span>
      </button>
    );
  }
}

Button.defaultProps = {
  type: 'button'
}

class ButtonTray extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { className } = this.props
    return (
      <div className={cx(styles.tray, className)}>
        {this.props.children}
      </div>
    );
  }
}

Button.Tray = ButtonTray;

export default Button;